var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company form-horizontal block"},[_c('div',{staticClass:"settings-company__container block"},[(_vm.getProcessName)?_c(`additional-${_vm.getProcessName}`,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }